module.exports = __webpack_public_path__ + "static/media/Fitbit_logo_RGB.dd1c586d.png";